import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const poolsJourneyRoutes = [
  {
    id: 'pools-choose-amount',
    trackingName: 'Pools Choose Amount',
    path: 'pool/choose-amount',
    lazy: async () => ({
      Component: (await import('../components/JourneyPoolChooseAmount')).JourneyPoolChooseAmount,
    }),
    // all modals for pools should be full screen
    target: 'fullscreen',
  },

  {
    id: 'pools-auth',
    trackingName: 'Pools Auth',
    path: 'pool/auth',
    lazy: async () => ({
      Component: (await import('../components/JourneyPoolAuth')).JourneyPoolAuth,
    }),
    // all modals for pools should be full screen
    target: 'fullscreen',
  },
] as const satisfies JourneyRoute[]
